// Mapping from taskId to taskName
export const taskNameMapping = {
  all: "All",
  day: "Day",
  night: "Night",
  clear: "Clear",
  fog: "Fog",
  rain: "Rain",
  snow: "Snow",
  undefined: "undefined"
};

// Mapping from challenge slug to challenge Name
export const challengeNameMapping = {
  panSeg: "Panoptic Segmentation",
  panSegUncertain: "Uncertainty-aware Panoptic Segmentation",
  semSeg: "Semantic Segmentation",
  objDet: "Object Detection",
};

export const modalitiesNameMapping = {
  frame_camera: 'Frame camera',
  event_camera: 'Event camera',
  lidar: 'Lidar',
  radar: 'Radar',
  ref_images: 'Reference Images'
};

export function getHrefLink(link: string): string {
  if (!link.startsWith("http")) {
    return "http://" + link;
  }
  return link;
}

export function getFullTaskName(task: string): string {
  return taskNameMapping?.[task];
}

export function getFullModalityName(modality: string): string {
  return modalitiesNameMapping?.[modality];
}

export function getFullChallengeName(challenge: string): string {
  return challengeNameMapping?.[challenge];
}


export function getSupervisionLabel(entry) {
  // supervised > unsupervised
  if (!entry.trainingData || entry.trainingData.length === 0)
    return "unsupervised"; // No information defaults to unsupervised. Should not happen with never version of backend

  if (entry.trainingData.indexOf("supervised") != -1) return "supervised"; // supervised is one of the supervision labels
  if (entry.trainingData.indexOf("unsupervised") != -1) return "unsupervised"; // unsupervised is one of the supervision labels
}


/**
 * Groups an object by its keys (comparable to SQL group by)
 * @param xs object
 * @param key key to group by
 */
export function groupBy(xs, key) {
  return xs.reduce(function(rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x);
    return rv;
  }, {});
}
